<template>
  <div>
  <template v-if="$route.name === 'EXSBItemCreate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'EXSBItemList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-tabs>
            <b-tab :title="$t('views.exsbitems.form.basicParameters')">
              <EXSBItemForm
                class="mt-2"
                :page="1"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations" />
            </b-tab>
            <b-tab :title="$t('views.exsbitems.form.advancedParameters')">
              <EXSBItemForm
                class="mt-2"
                :page="2"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations" />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </template>
  <template v-else>
    <b-row>
      <b-col>
        <EXSBItemForm
          :handle-submit="onSendForm"
          :handle-update-field="updateField"
          :values="item"
          :errors="violations" />
      </b-col>
    </b-row>
  </template>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapMutations } from 'vuex'
import EXSBItemForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'

const { mapGetters, mapActions } = createNamespacedHelpers('exsbitem/create')

export default {
  components: {
    EXSBItemForm
  },

  data () {
    return {
      item: {
        priceNetto: '0.00',
        priceBrutto: '0.00',
        customPrices: [],
        itemTags: [],
        isCyclic: 0,
        joinWithPreviousItemFromPriceGroup: 0,
        treatQuantityAsSingleFromPriceGroup: 0,
        canBeCyclic: false
      }
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBItemCreate')
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (this.$route.name === 'EXSBItemCreate') {
        this.$router.push({ name: 'EXSBItemShow', params: { id: created['@id'] } })
      } else {
        this.toggleModal()
      }
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),
    ...mapMutations({
      toggleModal: 'exsbitem/createModal/toggleModal'
    }),
    onSendForm () {
      let item = Object.assign({}, this.item)
      item.itemTags = this.item.itemTags.map(object => {
        return { tag: object.value }
      })
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
